<template>
  <template v-if="isEnabled">
    <dpc-input-tab-list
      v-if="isEnabled"
      v-model:value="currentTab"
      v-bind="$attrs"
      :name="id"
      :arrows-hidden="arrowsHidden"
      class="tab-list"
    >
      <slot />
    </dpc-input-tab-list>
    <portal-target :name="contentTargetName"></portal-target>
  </template>

  <template v-else>
    <slot />
  </template>
</template>

<script setup>
import { provide, nextTick, watch, ref, readonly, computed, toRefs } from 'vue';
import { useStore } from 'vuex';
import useUrlState from '@composables/use-url-state';
import { syncRef } from '@vueuse/core';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  initialTabItemId: {
    type: String,
  },
  requireBreakpointDown: {
    type: String,
  },
  useHistory: {
    type: Boolean,
    default: true,
  },
  nested: {
    type: Boolean,
    default: false,
  },
  arrowsHidden: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const { id, initialTabItemId, requireBreakpointDown, useHistory } =
  toRefs(props);

const currentTab = ref(initialTabItemId.value);

if (useHistory.value) {
  const { state: currentUrlTab } = useUrlState(`tablist-${id.value}`, {
    initialValue: initialTabItemId.value,
  });

  syncRef(currentUrlTab, currentTab, { immediate: true });
}

const contentTargetName = computed(() => {
  return `${id.value}-content`;
});

const isEnabled = computed(() => {
  if (!requireBreakpointDown.value) return true;

  return store.getters['window/breakpointDown'](requireBreakpointDown.value);
});

provide('tabList/id', readonly(id));
provide('tabList/currentTab', readonly(currentTab));
provide('tabList/contentTargetName', readonly(contentTargetName));
provide('tabList/isEnabled', readonly(isEnabled));
</script>

<script>
export default {
  compatConfig: {
    INSTANCE_ATTRS_CLASS_STYLE: false, // features can also be toggled at component level
  },
};
</script>
